<template>
  <div id="app" style="min-width: 1280px">
    <nv-bar v-if="!isGame"></nv-bar>
    <router-view></router-view>
    <nv-footerbar v-if="!isGame"></nv-footerbar>
    <nv-footer v-if="!isGame"></nv-footer>
    <div v-if="isGame" class="version_number">{{version[gameNameShow][0]}}</div>
    <div v-if="isGame" class="version_number">{{version[gameNameShow][1]}}</div>
  </div>
</template>

<script>
  import nvHeader from './components/header/header'
  import nvBar from './components/header/navbar'
  import nvFooterbar from './components/footer/footer_nav'
  import nvFooter from './components/footer/footer'
  import { mapState } from 'vuex'

  const Home={
    data(){
      return{
        isGame:false,
        gameNameShow:"",
        version:{
          chuanqi:['文网游备字[2017]M-RPG 1929号' ,'网络游戏出版物号（ISBN）：ISBN 978-7-89988-305-1'],
          rexue:['网络游戏出版物号（ISBN）：ISBN 978-7-498-04579-9',''],
          xiyou:['文网游备字[2018]M-RPG 0146号','网络游戏出版物号（ISBN）：ISBN 978-7-498-04394-8']
        }
      }
    },
    components:{
      nvHeader,
      nvBar,
      nvFooter,
      nvFooterbar
    },
    computed: mapState([
      'gameName'
    ]),
    methods:{
    },
    beforeMount(){
    },
    mounted:function(){
      this.isGame = (this.$router.currentRoute.path == "/toGame");
    },
    updated(){
      this.isGame = (this.$router.currentRoute.path == "/toGame");
      if(this.gameName == ""){
        this.gameNameShow = window.sessionStorage.getItem("gameName");
      }else{
        this.gameNameShow = this.gameName;
      }
    }
  }
  export default Home
</script>

<style>
  .version_number{
    background-color: black;
    color: #ffffff;
    text-align: center;
    height: 20px;
    line-height: 20px;
  }
</style>

